<img src="icons/info.svg" i18n-alt alt="Icon" />
<div>
  <h2 i18n>Note - this is a dynamic innovative space</h2>
  <p i18n>
    The content might change as we gain new knowledge. Some features will be at a very early stage, and content might be
    removed or replaced at any time.
  </p>
</div>
